import { useEffect, useRef } from 'react';
import { warningCopy } from './confetti';
import './WarningBanner.css';

const WarningBanner = ({ event }) => {
  const bannerRef = useRef(null);
  const copy = warningCopy(event);

  useEffect(() => {
    const banner = bannerRef.current;
    if (!banner) return undefined;

    const applyHeight = () => {
      document.documentElement.style.setProperty('--warning-banner-height', `${banner.offsetHeight}px`);
    };

    applyHeight();
    document.body.classList.add('has-season-warning');
    const observer = new ResizeObserver(applyHeight);
    observer.observe(banner);

    return () => {
      observer.disconnect();
      document.body.classList.remove('has-season-warning');
      document.documentElement.style.setProperty('--warning-banner-height', '0px');
    };
  }, [copy.title, copy.message]);

  return (
    <div className="season-warning" role="status" ref={bannerRef}>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
        <path fill="currentColor" d="M11 7h2v7h-2zM11 16h2v2h-2z" />
      </svg>
      <div>
        <h2>{copy.title}</h2>
        <p>{copy.message}</p>
      </div>
    </div>
  );
};

export default WarningBanner;
